import { Sun } from "lucide-react";
import { useCreateChain } from "../hooks/useCreateChain";
import { useCurrentSystem } from "../hooks/useCurrentSystem";
import { useActiveChainId } from "../hooks/useActiveChainId";

export function DayTripButton() {
  const { data: currentSystem } = useCurrentSystem();
  const createChain = useCreateChain();
  const [, setActiveChainId] = useActiveChainId();

  const disabled = !currentSystem || createChain.isPending;
  const title = !currentSystem
    ? "No current system"
    : createChain.isError
      ? createChain.error.message
      : "Create Day Trip chain";

  const handleClick = () => {
    if (!currentSystem) return;
    createChain.reset();
    createChain.mutate(
      {
        name: `Day Trip: ${currentSystem.name}`,
        root_system_id: Number(currentSystem.id),
        access: "private",
        chain_type: "day_trip",
      },
      {
        onSuccess: (created) => setActiveChainId(created.id),
      },
    );
  };

  return (
    <button
      type="button"
      className="topbar__shortcuts-btn"
      onClick={handleClick}
      disabled={disabled}
      aria-label="Create Day Trip chain"
      title={title}
    >
      <Sun size={14} aria-hidden />
    </button>
  );
}
